import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Translation, TranslocoLoader } from '@jsverse/transloco';
import { WA_WINDOW } from '@ng-web-apis/common';
import { Environment } from '@rma/public/generic/util/environment';
import { catchError, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
  private readonly httpClient = inject(HttpClient);
  private readonly environment = inject(Environment);
  private readonly window = inject<Window>(WA_WINDOW);

  public getTranslation(locale: string, data?: { scope: string }) {
    // replace the last occurance of - with _
    const localePath = locale.replace(/(\s*-)(?![\s\S]*-)/, '_');

    const { url, site } = this.environment.language;
    const assetsLangJson = data?.scope ? `${url}/scope/${localePath}.json` : `${url}/site/${site ?? 'public'}/${localePath}.json`;
    const showKeys = this.window.location.search.includes('doesthismakeyouhappyanton');
    return showKeys ? of({}) : this.httpClient.get<Translation>(assetsLangJson).pipe(catchError(() => of({})));
  }
}
